/** 
 * developed by Taha Arab in 15/06/2021.
 * 
 * DEVELOPED BY <3
 * 
 * all components child exported on {children} width app Footer and app Header
 **/

import { Flex } from "@mantine/core";
import LayoutContext from "context/layout";
import dynamic from "next/dynamic";
import Head from "next/head";
import { FC, ReactNode, useEffect, useState } from "react";
import IPageConfig from "rules/interface/config/config.interface";
import Header from './header';
const Footer = dynamic(() => import('./footer'))



interface IProps {
    children: ReactNode
    config: IPageConfig
}

const Layout: FC<IProps> = ({ children, config }) => {

    const [layout, setLayout] = useState<IPageConfig>(config)

    const {
        title,
        description,
        backgroundColor,
        config: { header, footer },
    } = layout;

    useEffect(() => {
        setLayout(config)
    }, [config])


    const isHeader = !header?.hide;
    const isFooter = !footer?.hide;

    return (
        <LayoutContext.Provider value={{ layout, setLayout }}>
            <>
                <Head>
                    <title>{title ?? "بازار آنلاین کابینت و دکوراسیون داخلی"}</title>
                    <meta name="description" key="description" content={description ?? "بزرگترین بازار آنلاین طراحی و سفارش انواع کابینت و کمد دیواری، معرفی بهترین کابینت سازها در سراسر ایران، تضمین کیفیت و قیمت"} />
                </Head>

                {isHeader && <Header {...header} />}

                <Flex
                    direction="column"
                    bg={backgroundColor ?? "#f7f7f7"}
                    className="w100"
                    display="block"
                    w="100%"
                >
                    {children}
                </Flex>

                {isFooter && <Footer {...footer} />}
            </>
        </LayoutContext.Provider>
    )
}

export default Layout